module.exports = __webpack_public_path__ + "img/7.d196e8b1.jpg";